import { createEvent, createStore } from 'effector'

export const actions = {
  setActivities: createEvent<FamilleResponse[]>('setActivities'),
  resetActivities: createEvent('resetActivities'),
  reset: createEvent('reset'),
}

const initialState: FamilleState = {
  activities: [],
}

export const store = createStore<FamilleState>(initialState, { name: 'famille' })
  .on(actions.setActivities, (s, activities) => ({ ...s, activities }))
  .on(actions.resetActivities, (s) => ({ ...s, activities: initialState.activities }))
  .reset(actions.reset)
